import { render } from "./Trade.vue?vue&type=template&id=41e83ac6&scoped=true"
import script from "./Trade.vue?vue&type=script&lang=js"
export * from "./Trade.vue?vue&type=script&lang=js"

import "./Trade.vue?vue&type=style&index=0&id=41e83ac6&lang=scss&scoped=true"
import "./Trade.vue?vue&type=style&index=1&id=41e83ac6&lang=scss"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41e83ac6"]])

export default __exports__